import React from 'react'
import NavLink from './NavLink'
import styled from 'styled-components'

import { device } from '../media'

const Nav = styled.nav`
  margin-top: 2.4994rem;
  margin-bottom: 0.889209325rem;
  line-height: 1;
  display: ${props => props.mobileDisplay};
  @media ${device.mobile} {
    display: block;
  }
`
const NavElement = styled.h2`
  display: inline;
  margin-right: 0.25em;
  margin-bottom: 0;
`

class Navbar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return(
      <Nav mobileDisplay={this.props.mobileDisplay}>
        <NavLink to='/'>We think from first principles.</NavLink>
        <NavLink to='/growth-opportunities'>We seek opportunities to grow.</NavLink>
        <NavLink to='/trust'>We trust who we work with.</NavLink>
        <NavLink to='/candid-conversations'>We have candid conversations.</NavLink>
      </Nav>
    )
  }
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/Navbar.js